import fcc from 'font-color-contrast';
import React from 'react';

import { Icon } from '@/components/_atoms/Icon';
import { schemas } from '@/network/client';
import { cn } from '@/utils/styles.utils';

type Campaign = schemas['ListingCampaign'];

interface Props extends Campaign {
  stretch?: boolean;
  extendOnMobile?: boolean;
}

export const ProductCampaignLabel = (props: Props) => {
  const { listing_label_color, listing_label, stretch = false, extendOnMobile = false } = props;
  const contrastColor = listing_label_color ? fcc(listing_label_color, 0.65) : undefined;
  return (
    <div
      style={{ backgroundColor: listing_label_color }}
      className={cn('inline-flex items-center rounded-[4px] bg-yellow p-[6px]', {
        'flex rounded-none': stretch,
        'max-laptop:min-h-12 max-laptop:w-full max-laptop:rounded-lg max-laptop:p-3': extendOnMobile,
      })}
    >
      <Icon
        name="star"
        size={16}
        className={cn('mr-1 size-4', {
          'max-laptop:size-5': extendOnMobile,
        })}
        style={{
          fill: contrastColor,
        }}
      />
      <span
        className={cn('flex-1 text-body-xs', {
          'max-laptop:text-body-l': extendOnMobile,
        })}
        style={{
          color: contrastColor,
        }}
      >
        {listing_label}
      </span>
    </div>
  );
};
